/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminPalletOrderAttachmentType,
    AdminPalletOrderAttachmentTypeFromJSON,
    AdminPalletOrderAttachmentTypeFromJSONTyped,
    AdminPalletOrderAttachmentTypeToJSON,
} from './AdminPalletOrderAttachmentType';

/**
 * 
 * @export
 * @interface AdminUpdatePalletOrderAttachmentMetaRequest
 */
export interface AdminUpdatePalletOrderAttachmentMetaRequest {
    /**
     * 
     * @type {AdminPalletOrderAttachmentType}
     * @memberof AdminUpdatePalletOrderAttachmentMetaRequest
     */
    type?: AdminPalletOrderAttachmentType;
}



export function AdminUpdatePalletOrderAttachmentMetaRequestFromJSON(json: any): AdminUpdatePalletOrderAttachmentMetaRequest {
    return AdminUpdatePalletOrderAttachmentMetaRequestFromJSONTyped(json, false);
}

export function AdminUpdatePalletOrderAttachmentMetaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdatePalletOrderAttachmentMetaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : AdminPalletOrderAttachmentTypeFromJSON(json['type']),
    };
}

export function AdminUpdatePalletOrderAttachmentMetaRequestToJSON(value?: AdminUpdatePalletOrderAttachmentMetaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': AdminPalletOrderAttachmentTypeToJSON(value.type),
    };
}

